"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _SelectMultipleFilter = _interopRequireDefault(require("../../../filter/SelectMultipleFilter"));

var _FilterConditionParameter = _interopRequireDefault(require("../../../filter/FilterConditionParameter"));

var _FilterConditionPrice = _interopRequireDefault(require("../../../filter/FilterConditionPrice"));

var _CatalogueProductListOrderSelectorButton = _interopRequireDefault(require("./CatalogueProductListOrderSelectorButton"));

var _CatalogueProductListMultipleFilterContainer = _interopRequireDefault(require("./CatalogueProductListMultipleFilterContainer"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'ProductListMultipleFilterDesktop'
});

function ProductListMultipleFilterDesktop(_ref) {
  var buildFilter = _ref.buildFilter,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      filter = _ref.filter,
      filterFields = _ref.filterFields,
      filterHash = _ref.filterHash,
      handleChangeOrder = _ref.handleChangeOrder,
      onChange = _ref.onChange,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      onChangeStockOnly = _ref.onChangeStockOnly,
      order = _ref.order,
      parentFilter = _ref.parentFilter,
      resetFilter = _ref.resetFilter,
      rowsPerPage = _ref.rowsPerPage,
      stockOnly = _ref.stockOnly,
      total = _ref.total,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "classes", "className", "currency", "filter", "filterFields", "filterHash", "handleChangeOrder", "onChange", "onChangeRowsPerPage", "onChangeStockOnly", "order", "parentFilter", "resetFilter", "rowsPerPage", "stockOnly", "total"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_CatalogueProductListMultipleFilterContainer.default, null, /*#__PURE__*/_react.default.createElement(_SelectMultipleFilter.default, {
    buildFilter: buildFilter,
    chipColor: "default",
    currency: currency,
    filter: filter,
    filterHash: filterHash,
    onChange: onChange,
    resetFilter: resetFilter,
    parentFilter: parentFilter,
    total: total
  }, /*#__PURE__*/_react.default.createElement(_FilterConditionParameter.default, {
    onChange: onChange,
    key: '_manufacturer',
    field: '_manufacturer',
    parameterName: '_manufacturer',
    buildFilter: buildFilter
  }), filterFields.map(function (f) {
    return /*#__PURE__*/_react.default.createElement(_FilterConditionParameter.default, {
      onChange: onChange,
      key: f,
      field: f,
      parameterName: f,
      buildFilter: buildFilter
    });
  }), /*#__PURE__*/_react.default.createElement(_FilterConditionPrice.default, {
    onChange: onChange,
    buildFilter: buildFilter,
    currency: currency,
    field: "price",
    priceField: "priceWithTax"
  }))), /*#__PURE__*/_react.default.createElement(_CatalogueProductListOrderSelectorButton.default, {
    value: order,
    onChange: handleChangeOrder,
    onChangeRowsPerPage: onChangeRowsPerPage,
    onChangeStockOnly: onChangeStockOnly,
    stockOnly: stockOnly,
    rowsPerPage: rowsPerPage
  }));
}

process.env.NODE_ENV !== "production" ? ProductListMultipleFilterDesktop.propTypes = {
  buildFilter: _propTypes.default.func,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  filter: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.shape(_propTypes.default.arrayOf())]),
  filterFields: _propTypes.default.arrayOf(_propTypes.default.string),
  filterHash: _propTypes.default.string,
  handleChangeOrder: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeRowsPerPage: _propTypes.default.func,
  onChangeStockOnly: _propTypes.default.func,
  order: _propTypes.default.string,
  parentFilter: _propTypes.default.arrayOf(_propTypes.default.shape()),
  resetFilter: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  stockOnly: _propTypes.default.bool,
  total: _propTypes.default.number
} : void 0;
ProductListMultipleFilterDesktop.defaultProps = {
  buildFilter: undefined,
  classes: undefined,
  className: undefined,
  currency: undefined,
  filter: undefined,
  filterFields: undefined,
  filterHash: undefined,
  handleChangeOrder: undefined,
  onChange: undefined,
  onChangeRowsPerPage: undefined,
  onChangeStockOnly: undefined,
  order: undefined,
  parentFilter: undefined,
  resetFilter: undefined,
  rowsPerPage: undefined,
  stockOnly: undefined,
  total: undefined
};
var _default = ProductListMultipleFilterDesktop;
exports.default = _default;